// @import dependencies
import React, { CSSProperties, useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
// @end dependencies

// @import components
import TextComponent from '../TextComponent/TextComponent';
// @end components

// @import types
// @end types

// @import services
import { routingService } from 'app_services/routingService';
// @end services

// @import hooks
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './ForumCard.scss'
import moment from 'moment';
import NewIndicatorComponent from '../NewIndicatorComponent/NewIndicatorComponent';
// @end styles

// @import assets
const FondoForo = require('app_assets/images/forums/fondo.png');
// @end assets

interface IForumCardProps {
  className?: string
  style?: CSSProperties
  id?: string
  title?: string
  description?: string
  forumId?: string
  reload?: boolean
  date?: string
}

const ForumCard: React.FC<IForumCardProps> = (props) => {

  const [reload, updateReload] = useState<boolean>(false);

  useEffect(() => {
    if (reload) {
      window.location.reload()
      updateReload(false)
    }
  }, [reload])

  const isNew = () => {
    let response = false;
    if (props.date) {
      const start = new Date(props.date)
      const end = new Date(props.date)
      end.setDate(start.getDate() + 15)
      if (moment().isBetween(start, end)) {
        response = true
      }
    }
    return response
  }

  return(
    <div
      className={`forum_card-layout ${props.className ? props.className : ''}`}
      style={props.style}
      id={props.id}
    >
      {isNew() ? <NewIndicatorComponent/> : null}
      <Link
        to={{
          pathname: routingService.getPublicPath(`/forum/${props.forumId}`),
        }}
        onClick={props.reload ? () => updateReload(true) : undefined}
      >
        <div
          className="content-card"
          style={{
            backgroundImage: `url(${FondoForo})`
          }}
        >
          <TextComponent
            type='text'
            className='text-card-forum'
          >
            {props.description ? props.description : ''}
          </TextComponent>
        </div>
        <div className="footer-card">
          <TextComponent
            type='text'
            className='text-footer-card'
            styleDiv={{
              width: '90%'
            }}
            elipsis
          >
            {props.title ? props.title : ''}
          </TextComponent>
        </div>
      </Link>
    </div>
  );
}

export default ForumCard;
